export class LoggerService {
  constructor(private name: string) {
    this.name = name;
  }

  public log(...params: any[]) {
    console.log(params);
  }
  public error(...params: any[]) {
    console.log(params);
  }
  public debug(...params: any[]) {
    console.log(params);
  }
  public info(...params: any[]) {
    console.log(params);
  }
  public warn(...params: any[]) {
    console.log(params);
  }
}
